function SickLeaveVO(id, medicalIndication, visitCard, issueDate, dateFrom, dateTo, feesPayerNip, icd10, attachment, alreadyPrinted) {
    this.id = id;
    this.medicalIndication = medicalIndication;
    this.visitCard = visitCard;
    this.issueDate = issueDate;
    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
    this.feesPayerNip = feesPayerNip;
    this.icd10 = icd10;
    this.attachment = attachment;
    this.alreadyPrinted = alreadyPrinted;

    var _typeContext = {
        visitCard: VisitCardVO,
        issueDate: Date,
        dateFrom: Date,
        dateTo: Date,
        icd10: DictionaryElementVO,
        attachment: AttachmentVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
